import { inject, Injectable } from '@angular/core';
import { CustomerService } from '@scripts/woo_services.module/CustomerService';
import { CompactCustomer, Customer, wooId } from '@scripts/woo_services.module/shared-types';

@Injectable({ providedIn: 'root' })
export class CachedCustomerService
  implements
    Pick<CustomerService, 'getCustomersForCurrentUser' | 'getCustomersForCurrentUserExcludingLocked' | 'getCustomer'> {
  private readonly customerService = inject(CustomerService);
  private listCache: CompactCustomer[] = null;
  private getCache = new Map<wooId, Customer>();

  async getCustomersForCurrentUser(): Promise<CompactCustomer[]> {
    if (!this.listCache) {
      this.listCache = await this.customerService.getCustomersForCurrentUser();
    }
    return this.listCache;
  }

  async getCustomersForCurrentUserExcludingLocked(): Promise<CompactCustomer[]> {
    if (!this.listCache) {
      this.listCache = await this.customerService.getCustomersForCurrentUserExcludingLocked();
    }
    return this.listCache;
  }

  async getCustomer(id: wooId): Promise<Customer> {
    if (!this.getCache.has(id)) {
      this.getCache.set(id, await this.customerService.getCustomer(id));
    }
    return this.getCache.get(id);
  }

  clear(customerId: wooId): void {
    this.getCache.delete(customerId);
  }
}
